export const namespace = "http://maf/promotion-engine";

export const endpoints = {
  LOGIN: "/users/login",
  USER_INFO: "/users/info",
  CREATE_CAMPAIGN: "/campaigns",
  FETCH_CAMPAIGNS: "/campaigns",
  SEARCH_CAMPAIGNS: "/campaigns/search",
  UPDATE_CAMPAIGN_STATUS: "/campaigns/{{object}}/{{id}}/status",
  GET_CAMPAGIN_BY_ID: "/campaigns/{{object}}/{{id}}",
  GET_CAMPAGIN_BY_ID_V2: "/campaigns/v2/{{object}}/{{id}}",
  UPDATE_CAMPAGIN_V2: "/campaigns/v2/{{object}}/{{id}}",
  GET_REPORT: "/campaigns/{{object}}/{{id}}/reports",
  EXTEND_CAMPAIGN: "/campaigns/{{object}}/{{id}}",
  DOWNLOAD_CSV: "/campaigns/coupon/{{id}}/csv",
  GET_RESOURCE_BY_ID: "/restrictions/{{id}}/download",
  CREATE_RESOURCE: "/resources",
  GET_USERS_LIST: "/users?page={{page}}",
  DELETE_USER_BY_ID: "/users/{{id}}",
  ADD_NEW_USER: '/users',
  UPDATE_USER_BY_ID: "/users/{{id}}",
  SHIPMENT_SERVICES: "/shipment-types",
  CREATE_BUNDLE_CAMPAIGN: "/v1/campaigns/{{type}}",
  FETCH_BUNDLE_CAMPAIGNS: "/v1/campaigns",
  GET_BUNDLE_CAMPAIGN_BY_ID: "/v1/campaigns/{{id}}",
  UPDATE_BUNDLE_CAMPAIGN_STATUS:"/v1/campaigns/{{id}}/status",
  CREATE_BUNDLE_POSINFO_RESOURCE: "/v1/posInfo/resources",
  GET_BUNDLE_POSINFO_RESOURCE: "/v1/posInfo/resources/{{id}}",
  GET_BUNDLE_POSINFO_RESOURCE_TEMPLATE: "/v1/templates/posInfo",
  GET_BULK_UPLOAD_RESOURCE_TEMPLATE: "/v1/bulk-campaigns/template/bundle-campaign",
  CREATE_BULK_BUNDLES : "/v1/bulk-campaigns",
  FETCH_BULK_BUNDLE_JOBS : "/v1/bulk-campaigns",
  UPDATE_BULK_BUNDLE_JOB_STATUS : "/v1/bulk-campaigns/{{id}}/{{status}}",
  GET_BULK_BUNDLE_JOB_BY_ID : "/v1/bulk-campaigns/{{id}}",
  FETCH_RECURRING_CAMPAIGNS: "/v1/promotion-calendar",
  CREATE_RECURRING_CAMPAIGN: "/v1/promotion-calendar",
  UPDATE_RECURRING_CAMPAIGN: "/v1/promotion-calendar/{{id}}",
  GET_RECURRING_CAMPAIGN_INSTANCES: "/v1/promotion-calendar/{{id}}/instances",
  GET_RECURRING_CAMPAIGN_BY_ID: "/v1/promotion-calendar/{{id}}",
  UPDATE_RECURRING_CAMPAIGN_STATUS: "/v1/promotion-calendar/{{id}}",
  SWITCH_STORE: "/users/switch-store",
};

export const staticApiEndpoints = {
  CONFIG: "/content/config/basic",
  FIELDS: "/content/promotion/{{type}}",
  PAYMENTS: "/payment-types",
};

export const absoluteUrls = {
  categories:
    "https://promotion-engine-search.search.windows.net/indexes/category/docs",
  brands:
    "https://promotion-engine-search.search.windows.net/indexes/brand/docs",
};

export const API_KEY_AZURE_SEARCH = process.env.REACT_APP_AZURE_KEY_SEARCH

